export default __webpack_public_path__ + "static/media/Owl_Loop.0b54ba99.wav";